export default {
	title: "Métodos de Pago",
	tips: "Estimado usuario, por favor complete su dirección ERC20/TRC20. Por favor, no ingrese los detalles de su cuenta bancaria ni su contraseña",
	form: {
		TransactionPassword: "Contraseña de Transacción",
		Address: "Dirección de la Billetera"
	},
	label: [
		"Nombre del banco",
		"Código de Sucursal",
		"Nombre de la Sucursal",
		"Tipo de Depósito",
		"Cuenta bancaria",
		"Titulares de cuentas bancarias"
	],
	tabs: ["Tarjeta Bancaria", "Red"],
	delete: "Eliminar",
	default: "Predeterminado",
	create: "Crear",
	type: "Tipo de Retiro",
	verifying: "verificando",
	VerifyWalletAddress: "Verificar dirección de cartera",
	defaultAccount: "Cuenta de Retiro Predeterminada",
	deleteMsg: "¿Está seguro de que desea eliminar?"
};
